export const SET_STATE = 'SET_STATE'; // 设置状态数据
export const INIT_STATE = 'INIT_STATE'; // 初始化状态数据
